import { ProductItem } from "../classes/ProductItem"
// Types
import { PrestationData } from "@/types/index"

// Builders
import buildPageCategoriesArr from "./buildPageCategories"

export function buildEcommerceItems(
	products: PrestationData[],
	packCode: string,
	averageRatingPerLihe: number,
	reviewNumberPerLihe: string,
	cheapestPrestationIndex: number
):
	| {
			ecommerce: { items: ProductItem[] }
	  }
	| undefined {
	if (!products || !products.length) {
		throw new Error("products are mandatory in buildEcommerceItems")
	}

	const {
		liheId,
		liheName,
		region,
		station,
		stationId,
		regionId,
		country,
		variants,
	} = products[0]

	if (!variants)
		throw new Error("variants are mandatory in buildEcommerceItems")
	const { duration, startDate, endDate } = variants[0]

	// Chepeast prestation
	const chepeastPrestation = products[cheapestPrestationIndex]

	if (!chepeastPrestation)
		throw new Error("chepeastPrestation is madnadory in buildEcommerceItems")

	const { variants: chepeastPrestationVariants } = chepeastPrestation

	if (!chepeastPrestationVariants || !chepeastPrestationVariants.length)
		throw new Error(
			"chepeastPrestationVariants are mandatory in buildEcommerceItems"
		)

	const cheapestPrestationVariant = chepeastPrestationVariants[0]

	// pricePerLogementWithoutFee does not exist on page load, so replace it with pricePerLogement
	const cheapestVariantPrice: number =
		packCode !== "HS" && cheapestPrestationVariant.pricePerLogementWithoutFee
			? cheapestPrestationVariant.pricePerLogementWithoutFee
			: cheapestPrestationVariant.pricePerLogement

	const prestIdsArr = buildProductPrestIdsArr(products)
	const prestNamesArr = buildProductPrestNamesArr(products)
	const categoriesArr: string[] = buildPageCategoriesArr()
	const ecommerceItems: ProductItem[] = []
	const productItem = new ProductItem()

	// Assign values to its properties
	productItem.item_LiheId = liheId
	productItem.item_LiheName = liheName
	productItem.item_PrestIds = prestIdsArr
	productItem.item_PrestNames = prestNamesArr
	productItem.item_price_ati = cheapestVariantPrice || 0
	productItem.page_category1 = categoriesArr[0] || region
	productItem.page_category2 = categoriesArr[1] || station
	productItem.page_category3 = categoriesArr[2] || "" // Empty string for page_category3
	productItem.page_category4 = categoriesArr[3] || "" // Empty string for page_category4
	productItem.item_variant = packCode
	productItem.item_ville_name = station
	productItem.item_ville_id = stationId || ""
	productItem.item_region_name = region || ""
	productItem.item_region_id = regionId || ""
	productItem.item_pays_name = country || ""
	productItem.item_pays_id = country || ""
	;(productItem.item_begin_date = new Intl.DateTimeFormat("fr-FR").format(
		new Date(startDate)
	)),
		(productItem.item_end_date = new Intl.DateTimeFormat("fr-FR").format(
			new Date(endDate)
		))
	productItem.item_duration = `${duration} days`
	productItem.item_reviews_note =
		averageRatingPerLihe?.toFixed(1).toString() || ""
	productItem.item_reviews = reviewNumberPerLihe || ""
	productItem.pageName = window.lihe.name || ""
	productItem.position = 0

	productItem.isValid()

	ecommerceItems.push(productItem)

	return {
		ecommerce: {
			items: ecommerceItems,
		},
	}
}

function buildProductPrestIdsArr(prestations: PrestationData[]): string[] {
	if (!prestations || !prestations.length)
		throw new Error("prestations are mandatory in buildProductPrestIdsArr")
	return prestations.map(
		(prestation: PrestationData) => prestation.prestationId
	)
}

function buildProductPrestNamesArr(prestations: PrestationData[]): string[] {
	if (!prestations || !prestations.length)
		throw new Error("prestations are mandatory in buildProductPrestIdsArr")
	return prestations.map(
		(prestation: PrestationData) => prestation.accomodationName
	)
}
